import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CookieConsentService } from '../data-access/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent-dialog',
  imports: [RouterLink],
  templateUrl: './cookie-consent-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieConsentDialogComponent {
  readonly cookieConsentService = inject(CookieConsentService);
}
